import { LitElement, html, css } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";

export class BudgetComponent extends LitElement {
	static properties = {
		pricingType : {type : String},
		tva : {type : String},
		totalTVA : {type : String},
		totalTTC : {type : String},
		journals : {type : Array}
	};
	
	createRenderRoot (){
		return this;
	}
	
	constructor (){
		super ();
		this.journals = [];
		this.pricingType = "";
		this.tva = "";
		this.totalTVA = "";
		this.totalTTC = "";
	}
	
	render (){
		const notAvailable = "Pas disponible";
		
		// Check if all TVA rates are the same
		const tvaRates = this.journals.map(j => j.tvaRate).filter(r => r != null);
		const showIndividualTva = tvaRates.length > 0 && !tvaRates.every(rate => rate === tvaRates[0]);
		
		return html`
			<div class="recap-commande">
			<strong>Récapitulatif de votre commande - ${this.pricingType ? this.pricingType : notAvailable}</strong><br>
			${this.journals.map (journal => html`
				<div>
					Parution sur ${journal.name} (${journal.postalCode}) : ${journal.prixHT}
					${showIndividualTva && journal.tvaRate ? html`<br><span style="margin-left: 20px;">TVA à ${(journal.tvaRate / 100).toFixed(2)} %</span>` : ''}
				</div>
			`)}
			${this.tva ? html`TVA à ${this.tva} ${this.totalTVA ? this.totalTVA : notAvailable}<br>` : this.totalTVA ? html`${this.totalTVA}<br>` : ''}
			<strong>Total TTC ${this.totalTTC ? this.totalTTC : notAvailable}</strong></div>
		`;
	}
}

customElements.define ("budget-component", BudgetComponent);
